import React from "react";
import "./Cart.sass";
import {ReactComponent as Close} from "../../svg/Close.svg";
import {ReactComponent as Trash} from "../../svg/Trash.svg";
const {Translations: {cart}} = window;

const Cart = ({selected = [], onDelete, onClear}) => {
  return (
      <div className="Cart">
          <div className="Cart-title">
              {cart.title}
              &nbsp;
              <span>
                  ({selected.length}/22)
              </span>
              <span className="Cart-deletebtn" onClick={onClear}>
                  <Trash />
                  {cart.deleteButton}
              </span>
          </div>
          <div className="Cart-scroll">
              {selected.map((item, i) => (
                  <div className="Cart-item" key={i}>
                      <img className="Cart-img" src={item.images.card} alt=""/>
                      <div className="Cart-delete" onClick={() => onDelete(item.itemId)}>
                          <Close />
                      </div>
                  </div>
              ))}
          </div>
      </div>
  )
};

export default Cart
